module.exports = __webpack_public_path__ + "img/aboutustruck.7fd769b0.png";